import React from 'react';
import TermGIT from './TermGIT';
import TermTDH from './TermTDH';

const TermsConditions = ({ siteId }) => {
  if (siteId == 2) return <TermGIT />;

  return <TermTDH />;
};

export default TermsConditions;
